import { useState } from 'react';
import { EnvelopeIcon, PaperAirplaneIcon } from '@heroicons/react/20/solid';
import request from '../../../../lib/request';

const Settings = ({ newUserInfo }) => {
  const [formData, setFormData] = useState({
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const name = `${newUserInfo.firstname} ${newUserInfo.lastname}`;
      const email = newUserInfo.email;

      const { result } = request.post('/email/support', {
        name,
        email,
        subject: formData.subject,
        message: formData.message,
      });

      setSubmitStatus('success');
      setFormData({
        subject: '',
        message: '',
      });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='py-2'>
      <div className='text-center mb-8'>
        <h1 className='text-xl font-bold text-gray-900 mb-2'>
          Have a Question?
        </h1>
        <p className='text-gray-600'>
          I'd love to hear from you! Whether you're curious about our features,
          have feedback, or want to explore partnerships — drop us a message.
        </p>
      </div>

      <div className='flex flex-col gap-8 mb-8'>
        <div className='flex-1'>
          <div className='bg-yellow-50 rounded-lg p-4 border border-yellow-100'>
            <div className='flex items-center gap-3 mb-4'>
              <EnvelopeIcon className='w-6 h-6 text-yellow-500' />
              <h2 className='text-lg font-semibold text-gray-900'>Email Us</h2>
            </div>
            <p className='text-gray-600 mb-2'>
              For direct inquiries, you can reach us at:
            </p>
            <a
              href='mailto:support@thechamps.app'
              className='text-yellow-600 hover:text-yellow-700 font-medium'
            >
              support@thechamps.app
            </a>
          </div>
        </div>

        <div className='flex-1'>
          <form
            onSubmit={handleSubmit}
            className='space-y-4'
          >
            <div>
              <label
                htmlFor='subject'
                className='block text-sm font-medium text-gray-700 mb-1'
              >
                Subject
              </label>
              <input
                type='text'
                id='subject'
                name='subject'
                value={formData.subject}
                onChange={handleChange}
                required
                className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent'
                placeholder='How can we help?'
              />
            </div>

            <div>
              <label
                htmlFor='message'
                className='block text-sm font-medium text-gray-700 mb-1'
              >
                Message
              </label>
              <textarea
                id='message'
                name='message'
                value={formData.message}
                onChange={handleChange}
                required
                rows={4}
                className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent'
                placeholder='Tell us more about your inquiry...'
              />
            </div>

            <button
              type='submit'
              disabled={isSubmitting}
              className='w-full flex items-center justify-center gap-2 px-6 py-3 bg-yellow-500 text-white font-medium rounded-lg hover:bg-yellow-600 focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {isSubmitting ? (
                'Sending...'
              ) : (
                <>
                  <PaperAirplaneIcon className='w-5 h-5' />
                  Send Message
                </>
              )}
            </button>

            {submitStatus === 'success' && (
              <div className='mt-4 p-4 bg-green-50 text-green-700 rounded-lg'>
                Message sent successfully! We'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className='mt-4 p-4 bg-red-50 text-red-700 rounded-lg'>
                Something went wrong. Please try again later.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Settings;
